<script setup lang="ts">
// Route-scoped: the banner belongs to the auction the URL names, not to
// whatever the detail cache last held. The cache survives the trip home, and
// App's RouterView is the only ancestor every auction page shares — the
// shell-less ones included — so the route param decides, and the cache only
// supplies the event once its uuid matches.
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Message from 'primevue/message';

import { useCurrentAuction } from '@/shell/stores/currentAuction';
import { archivedBannerMessage, routeAuctionId } from '@/shell/lib/archivedBanner';

const route = useRoute();
const currentAuction = useCurrentAuction();

const ICON = 'pi pi-inbox';

const message = computed<string | null>(() => {
  const uuid = routeAuctionId(route.params.id);
  const event = currentAuction.event;
  if (!uuid || !event || event.uuid !== uuid) return null;
  return archivedBannerMessage(event);
});
</script>

<template>
  <!-- archived-auction-states.md §Banner -->
  <div
    v-if="message"
    class="archived-banner"
    data-testid="archived-banner"
  >
    <Message
      severity="info"
      :icon="ICON"
      :closable="false"
      class="archived-banner__message"
    >
      {{ message }}
    </Message>
  </div>
</template>

<style scoped>
/* docs/design/wireframes/admin/archived-auction-states.md §Banner — one strip above every auction page,
   on the page background so it reads as the frame's, not the page's. */
.archived-banner {
  flex-shrink: 0;
  padding: var(--app-space-12) var(--app-space-24);
  background: var(--app-background-primary);
}

/* docs/design/wireframes/admin/archived-auction-states.md §Banner */
.archived-banner__message {
  width: 100%;
}
</style>
